import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'concept',
    templateUrl: './concept.component.html',
    styleUrls: ['./concept.component.scss']
})
export class ConceptComponent implements OnInit {
    private fragment: string;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.fragment.subscribe(f => this.fragment = f);
    }

    ngAfterViewInit() {
        try {
            document.querySelector('#' + this.fragment).scrollIntoView();
        } catch (e) { }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/concept.component.ts